<template>
  <div id="changePassword">
    <b-container v-if="authenticated">
      <h2>You are logged as {{ userLogin }}.</h2>
      <h4>Please enter your new password</h4>
      <b-form @submit="changePassword">
        <password
          id="newPassword"
          v-model="input.newPassword"
          type="password"
          required
          placeholder="Enter the new password"
          :toggle="true"
          secure-length:8
          @feedback="showFeedback"
          @input="resetMessageAlert"
          @score="setScore"
        ></password>
        <password
          id="newPassword2"
          v-model="input.newPassword2"
          type="password"
          required
          placeholder="Enter the new password a second time"
          :toggle="true"
          secure-length:8
          :badge="false"
          :show-strength-meter="false"
          @input="resetMessageAlert"
        ></password>
        <b-alert :show="showMessageSubmit" :variant="variant">{{ messageSubmit }}</b-alert>
        <b-alert :show="showSuggestions" variant="info">{{ messageSuggestions }}</b-alert>
        <b-alert :show="showWarnings" variant="warning">{{ messageWarnings }}</b-alert>
        <b-button type="submit" variant="primary">Submit</b-button>
      </b-form>
    </b-container>
    <b-container v-else>
      <h2>You are not logged. Please login.</h2>
    </b-container>
  </div>
</template>

<script>
import Password from 'vue-password-strength-meter';
import Vue from 'vue';

export default {
  name: 'ChangePassword',
  components: { Password },
  data() {
    return {
      input: {
        newPassword: null,
        newPassword2: null,
      },
      score: 0,
      status: 'success',
      messageSubmit: '',
      messageSuggestions: '',
      messageWarnings: '',
      variant: 'danger',
    };
  },
  computed: {
    authenticated: function() {
      return this.$store.getters.isLoggedIn;
    },
    userLogin: function() {
      return this.$store.getters.getLogin;
    },
    showMessageSubmit: function() {
      return this.messageSubmit !== '';
    },
    showSuggestions: function() {
      return this.messageSuggestions !== '';
    },
    showWarnings: function() {
      return this.messageWarnings !== '';
    },
  },
  methods: {
    changePassword(evt) {
      evt.preventDefault();

      if (this.input.newPassword !== this.input.newPassword2) {
        this.messageSubmit = 'The two passwords must be identical';
        this.variant = 'danger';
      } else {
        if (this.score >= 3) {
          let form = {};
          form.login = this.$store.getters.getLogin;
          form.token = this.$store.getters.getToken;
          form.pwd = this.input.newPassword;
          Vue.http.post('api/change_password', form).then(
            resp => {
              var success = resp.body.success;
              if (success === false) {
                this.variant = 'danger';
                this.messageSubmit = resp.body.message;
              } else {
                this.variant = 'success';
                this.messageSubmit = 'Your password has been successfully changed';
              }
            },
            () => {
              this.variant = 'danger';
              this.messageSubmit = 'Server error';
            }
          );
        } else {
          this.variant = 'danger';
          this.messageSubmit = 'Password not strong enough';
        }
      }
    },
    showFeedback({ suggestions, warning }) {
      this.messageSuggestions = '';

      if (suggestions.length > 0) {
        this.messageSuggestions = '🙏 ';
        let suggStr = suggestions.join('\n');
        this.messageSuggestions += suggStr;
      }

      this.messageWarnings = '';
      if (warning != '') {
        this.messageWarnings = '⚠ ' + warning;
      }
    },
    setScore: function(score) {
      this.score = score;
    },
    resetMessageAlert() {
      this.messageSubmit = '';
    },
  },
};
</script>

<style scoped>
#changePassword {
  text-align: left;
  margin: 100px 10px 10px 10px;
}

.Password {
  margin: 0 !important;
}

.Password__badge {
  height: 20px !important ;
}

.alert {
  margin: 10px 0px 0px 0px;
}

button {
  margin: 10px 0px 0px 0px;
}
</style>
